import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule, SharedModule } from '../../shared';
import { CoreModule } from '../../core/core.module';
import { CommonModule, DatePipe } from '@angular/common';
import { HomeMarketBonusContainer } from './home-market-bonus-container/home-market-bonus.container';
import { HomeMarketBonusRoutingModule } from './home-market-bonus-routing.module';
import { HomeMarketBonusFilterComponent } from './home-market-bonus-filter/home-market-bonus-filter';
import { EpsToggleModule } from '@dlw-int-mwi/eps-common';
import { TranslateRolePipe } from './home-market-bonus-container/translate-role.pipe';

@NgModule({
  imports: [CommonModule, HomeMarketBonusRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule, EpsToggleModule],
  exports: [],
  declarations: [
    HomeMarketBonusContainer,
    HomeMarketBonusFilterComponent,
    TranslateRolePipe,
  ],
  providers: [DatePipe],
})
export class HomeMarketBonusModule {
}
